import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-62af4e32")

_pushScopeId("data-v-62af4e32")
const _hoisted_1 = { class: "min-h-screen bg-white flex" }
const _hoisted_2 = { class: "flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24" }
const _hoisted_3 = { class: "mx-auto w-full max-w-sm lg:w-96" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", { class: "mt-6 text-3xl font-extrabold text-gray-900" }, " Sign in to your account ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "mt-2 text-sm text-gray-600" }, [
  /*#__PURE__*/_createTextVNode(" Or " + /*#__PURE__*/_toDisplayString(' ') + " ", 1 /* TEXT */),
  /*#__PURE__*/_createVNode("a", {
    href: "https://weeconnectpay.com/register/",
    class: "font-medium text-indigo-600 hover:text-indigo-500"
  }, " start your 14-day free trial ")
], -1)
const _hoisted_6 = { class: "mt-8" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "text-sm font-medium text-gray-700" }, " Sign in with ", -1)
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = { class: "inline-flex justify-center w-2/5" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Sign in with Clover", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  "aria-hidden": "true",
  viewBox: "0 0 88 22"
}, [
  /*#__PURE__*/_createVNode("path", {
    class: "st0",
    d: "M36.3 14.6c-1.4 1.7-3.4 2.8-5.6 2.8-3.8 0-6.8-2.7-6.8-6.2 0-1.7.7-3.3 2-4.5 1.2-1.2 2.9-1.8 4.6-1.7 2.2 0 4.3 1 5.6 2.8l-2.5 1.8c-.7-1.1-1.8-1.8-3.1-1.8-1.9 0-3.5 1.6-3.5 3.5.1 2 1.7 3.5 3.6 3.5 1.3 0 2.5-.6 3.2-1.7l2.5 1.5zM37.7 0h3.1v17.1h-3.1zM49.1 14.7c2 0 3.7-1.6 3.8-3.6-.1-2-1.8-3.6-3.8-3.6s-3.7 1.6-3.8 3.6c.1 2 1.7 3.6 3.8 3.6m0-9.8c1.7-.1 3.4.5 4.7 1.7 1.3 1.2 2 2.8 2.1 4.5-.1 1.7-.8 3.4-2.1 4.5-1.3 1.2-3 1.8-4.7 1.7-3.8 0-6.8-2.7-6.8-6.2s3-6.2 6.8-6.2M55.3 5.1H59l3 6.4 3.2-6.4h3.4L62 17.8zM77.5 9.4c-.5-1.2-1.6-1.9-2.9-1.9-1.3 0-2.5.7-3.1 1.9h6zm2 6.3c-1.3 1.1-2.9 1.6-4.6 1.6-3.8 0-6.8-2.7-6.8-6.2 0-1.7.7-3.3 1.9-4.5 1.2-1.2 2.9-1.8 4.6-1.7 1.7-.1 3.3.6 4.5 1.8s1.8 2.8 1.7 4.5v.8h-9.6c.5 1.6 2 2.7 3.7 2.7 1 0 2-.4 2.8-1.2l1.8 2.2zm2.8-5.3c0-2.9 2.2-5.2 5.7-5.2V8c-.7 0-1.5.3-2 .8s-.7 1.3-.6 2v6.3h-3.1v-6.7z",
    style: {"fill":"#5a5a5a"}
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M9.7 5.6c0-2-1.2-3.7-3-4.5s-3.9-.4-5.3 1S-.4 5.6.3 7.4s2.5 3 4.5 3h4.9V5.6zm1.4 0c0-2 1.2-3.7 3-4.5s3.9-.4 5.3 1 1.8 3.5 1.1 5.3-2.5 3-4.5 3h-4.9V5.6zm0 11c0 2 1.2 3.7 3 4.5 1.8.8 3.9.4 5.3-1s1.8-3.5 1.1-5.3-2.5-3-4.5-3h-4.9v4.8zm-6.3 3.5c1.9 0 3.5-1.5 3.5-3.5v-3.5H4.8c-1.9 0-3.5 1.5-3.5 3.5s1.6 3.5 3.5 3.5zm4.9-3.5c0 2-1.2 3.7-3 4.5-1.8.8-3.9.4-5.3-1S-.4 16.6.3 14.8s2.5-3 4.5-3h4.9v4.8z",
    style: {"fill":"#280"}
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-6 relative\" data-v-62af4e32><div class=\"absolute inset-0 flex items-center\" aria-hidden=\"true\" data-v-62af4e32><div class=\"w-full border-t border-gray-300\" data-v-62af4e32></div></div><div class=\"relative flex justify-center text-sm\" data-v-62af4e32><span class=\"px-2 bg-white text-gray-500\" data-v-62af4e32> Or </span></div></div>", 1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "mt-6" }, [
  /*#__PURE__*/_createVNode("a", { href: "https://weeconnectpay.com/register/" }, [
    /*#__PURE__*/_createVNode("button", {
      type: "button",
      class: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white  hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2",
      style: {"background-color":"#59B210"}
    }, " Create an account ")
  ])
], -1)
const _hoisted_14 = { class: "hidden lg:block relative w-0 flex-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", null, [
          _createVNode("img", {
            class: "h-36 w-auto mx-auto",
            src: $options.weeconnectpayLogoSrc,
            alt: "weeconnectpay-logo"
          }, null, 8, ["src"]),
          _hoisted_4,
          _hoisted_5
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", null, [
            _createVNode("div", null, [
              _hoisted_7,
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("a", {
                    href: $setup.authRedirect,
                    class: "w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                  }, [
                    _hoisted_10,
                    _hoisted_11
                  ], 8, ["href"])
                ])
              ])
            ]),
            _hoisted_12
          ]),
          _hoisted_13
        ])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("img", {
        class: "absolute inset-0 h-full w-full object-cover",
        src: $options.signInCoverSrc,
        alt: "weeconnectpay-sign-in-cover"
      }, null, 8, ["src"])
    ])
  ]))
})